import React, { useEffect, useState } from "react";
import { AppDispatch } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { editSpa } from "../../../redux/actions/spa.actions";
import RootState from "../../../redux/states/root.state";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import ModalShell, { ModalLoading } from "../../../components/common/Modals/ModalShell";
import { clearError } from "../../../redux/reducers/spa.reducer";


const EditNicknameModal: React.FC<ModalProps> = ({open, setOpen}) => {
    const dispatch: AppDispatch = useDispatch();
    const {data:spa, error: spaError} = useSelector((state: RootState) => state.spa);
    const [input, setInput] = useState(``);
    const [submitted, setSubmitted] = useState(false);
    const [success, setSuccess] = useState(false);
    const [updating, setUpdating] = useState(false);
    // Only show errors from this modal's own request, not the page's fetches on the same slice.
    const error = submitted ? spaError : null;


    useEffect(() => {
        if (spa && open) {
          setInput(spa.nick_name??'');
        }
    }, [spa, open])

    const handleClose = () => {
      dispatch(clearError());
      setInput(``);
      setSubmitted(false);
      setSuccess(false);
      setOpen(false);
    };

    /* Handle text input */
    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        let input = e.target.value;
        setInput(input);
    };

    const handleEdit = async () => {
        setSubmitted(true);
        setUpdating(true);
        const result = await dispatch(editSpa({guid:spa?.id,nick_name:input}));
        setSuccess(editSpa.fulfilled.match(result));
        setUpdating(false);
    }

  const done = Boolean(error) || success;

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size="sm"
      busy={updating}
      tone={updating ? undefined : error ? "error" : success ? "success" : undefined}
      title={updating ? "Updating spa…" : error ? "An error occurred" : success ? "Nickname updated" : "Edit nickname"}
      subtitle={!updating && !done ? "Shown on the spa list and across the portal." : undefined}
      actions={updating ? undefined : done ?
        <button className="btn btn-primary" onClick={handleClose}>Done</button>
        :
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleEdit}>Save</button>
        </>
      }
    >
      {updating ?
        <ModalLoading/>
        : error ?
        <p>{error}</p>
        : success ?
        <p>The spa's nickname is now <strong>{input || spa?.nick_name}</strong>.</p>
        :
        <form className="field" onSubmit={(e) => { e.preventDefault(); handleEdit(); }}>
          <label className="field-label" htmlFor="spa-nickname-input">Nickname</label>
          <input id="spa-nickname-input" className="input" type="text" value={input} onChange={handleInput} autoFocus/>
        </form>
      }
    </ModalShell>
  );
};

export default EditNicknameModal;
